import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

type SelectedProductState = {
  product: Product | null
}

/* Sample Product:
{
  id: 1,
  name: 'Nike Men’s Sportswear V-Neck Adjustable T-shirt, Small',
  price: 24000.0,
  currency: 'LKR',
  image: '/dummy/product-images/001.png',
  sku: 'KS93538TUT',
  barcode: '480528304523',
  stock: 10,
}
*/

const initialState: SelectedProductState = {
  product: null,
}

const selectedProductSlice = createSlice({
  name: 'selected-product',
  initialState,
  reducers: {
    resetSelectedProduct() {
      return initialState
    },
    selectProduct(state, action: PayloadAction<Product | null>) {
      state.product = action.payload
    },
  },
})

export const { resetSelectedProduct, selectProduct } = selectedProductSlice.actions

export default selectedProductSlice.reducer
